import React, { useEffect, useCallback, useState} from 'react';
import MacroInfo from './MacroInfo.js';
import DeviceParameter from './DeviceParameter.js';
import Colors from 'components/Colors.js';
import {searchForParameters} from './searchForParameters.js';
import {connect} from 'react-redux';
import {
    setAccumulatorParameterSelected,
    setIsMacroMapping} from 'actions/index.js';

const colors = new Colors();

const PlaneSiderbar = ({
    macroToShow,
    setMacroToShow,
    setSelected,
    effect,
    setFilteredParameters,
    selected,
    filteredParameters=[],
    setParameter,
    parameterSelected,
    expanded,
    isBoundsMode
}) => { 
    let [hide, setHide] = useState(false);
    let [searchTerm, setSearchTerm] = useState('');
    
    useEffect(() => {
        if (searchTerm === '') {
            setFilteredParameters(undefined);
        } else {
            // otherwise search for them
            setFilteredParameters(
                searchForParameters(
                    effect,
                    searchTerm));
        }
        setSelected([]);
    }, [effect, setSelected, searchTerm, setFilteredParameters]);
   
    let params = filteredParameters.length > 0 ? filteredParameters : selected;
    // sub devices

    let macro = false;
    if (params[0] && params[0].isPlaneMacro) {
        macro = params[0];
        params = macro.parameters;
    }

    if (!macro && macroToShow) {
        macro = macroToShow;
    }

    let groups = [... getGroupsFromParams(params), undefined];
    let groupToDevices = {};
    for (let group of groups) {
        let groupParams = params.filter(
            p => p.hasGroup === group);
        if (groupParams.length === 0) {
            continue;
        }
        let devices = {};
        for (let p of groupParams) {
            let device = "Other";
            if (p.context) {
                device = p.context.subDevice ?
                    p.context.subDevice.name :
                    p.context.effect ?
                    p.context.effect.name :
                    p.context.midiEffect ?
                    p.context.midiEffect.name  :
                    p.context.instrument ?
                    p.context.instrument.getName() :
                    p.context.lfoTrack ?
                    "LFO " + p.context.lfoTrack.lfo.number :
                    "Other";
            }
            if (!devices[device]) {
                devices[device] = [];
            }
            devices[device].push(p);
        }

        groupToDevices[group ? group.id : 0] = devices;
    }

    // Need to divide the results by groups if  there are filtered parameters

    if (hide) {
        return (
            <div
              draggable={true}
              onDragStart={e => e.preventDefault()}
              onDragOver={(e) => e.preventDefault()}
              className="plane-sidebar hide">
              <div className="sidebar-header">
                <div className="collapse-toggle">
                  <div onClick={() => setHide(!hide)} className={hide ? "arrow-down" : "arrow-right"}></div>
                </div>
              </div>
            </div>);
    }
    return (
        <div
          draggable={true}
          onDragStart={e => e.preventDefault()}
          onDragOver={(e) => e.preventDefault()}
          className="plane-sidebar">
          {expanded ? 
           <div className="sidebar-header">
             <div className="collapse-toggle">
               <div onClick={() => setHide(!hide)} className="arrow-right"></div>
             </div>
           </div>
           : ''}
          <div className="plane-search-container">
            <input value={searchTerm}
                   onChange={e => setSearchTerm(e.target.value)}
                   type="text"
                   placeholder="Search for parameters"
                   className="plane-search"
            />
            <div
              onClick={() => setSearchTerm('')}
              className="clear-btn">
              x
            </div>
          </div>
          <div className="plane-results parameters-list">
            {macro && <MacroInfo macroToShow={macroToShow} setMacroToShow={setMacroToShow} macro={macro}/>}
            {Object.keys(groupToDevices).map(
                (groupId, i) =>
                    <div key={groupId} className="plane-param-group">
                      <div
                        className="group-parameters-name">
                        <div
                          onClick={
                              () => setSelected(
                                  groupId === "0" ? params.filter(x => !x.hasGroup) :
                                      params.filter(x => x.hasGroup && x.hasGroup.id === groupId))}
                          className="group-thumb"
                          style={
                              {
                                  backgroundColor: groupId === "0" ? "gray" : colors.getColorForHash(groupId)
                              }
                          }
                        >
                        </div>
                        <div>
                        {groupId === "0" ? "Not Grouped" : "Group " + (effect.groups.map(x => x.id).indexOf(groupId) + 1)}
                        </div>
                      </div>
                      <div className="group-parameters">
                        {Object.keys(groupToDevices[groupId])
                         .map(x => <Device
                                     key={x.id}
                                     setSelected={setSelected}
                                     isBoundsMode={isBoundsMode}
                                     selected={selected}
                                     setParameter={setParameter}
                                     parameterSelected={parameterSelected}
                                     device={x}
                                     parameters={groupToDevices[groupId][x]}/>)}
                      </div>
                    </div>)}
          </div>
        </div>
    );
}

const Device = ({
    device,
    parameters,
    parameterSelected,
    setParameter,
    setSelected,
    selected,
    isBoundsMode
}) => {
    useEffect(() => {
        return () => parameters.includes(parameterSelected) ?
            setParameter(undefined) : undefined;
    }, [parameterSelected, parameters]);

    let _parameters = parameters.filter(
        x => !x.isPlaneMacro);

    return (
        <div className="device">
          <div className="device-name">{device}</div>
          <div className="device-parameters">
            {_parameters.map(
                p =>
                    <DeviceParameter
                      isBoundsMode={isBoundsMode}
                      setSelected={setSelected}
                      selected={selected}
                      parameter={p}
                      setParameter={setParameter}
                      parameterSelected={parameterSelected}
                    />)}
         </div>
        </div>
    );
};


const mapStateToProps = (state, props) => {
  return {
      parameterSelected: state.effects.accumulatorParameterSelected
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
      setParameter: (param) => dispatch(
          setAccumulatorParameterSelected(param))
  };
};

const getGroupsFromParams = (params) => {
    let groups = new Set();
    for (let param of params) {
        if (param.hasGroup) {
            groups.add(param.hasGroup);
        }
    }
    return Array.from(groups);
};

export default connect(mapStateToProps, mapDispatchToProps)(PlaneSiderbar);
